<template>
  <div>
    <component :is="view"> </component>
  </div>
</template>

<script>
import Spve from './Sprc.vue'
export default {
  computed: {
    view() {
      if (this.$store.state.apiKey == 'SPVC') {
        return 'Spve'
      } else {
        return 'Spve'
      }
    }
  },
  components: {
    Spve
  }
}
</script>

<style lang="scss" scoped></style>
